import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useSetReturnToStoreActivation(shopId: string) {
  const invalidateShop = useInvalidateShop(shopId);

  return useApiMutation(
    "put",
    "/shops/{shopId}/return-to-store/stores/activation",
    {
      invalidate: invalidateShop,
      mapVariables: (active: boolean) => ({
        params: { path: { shopId } },
        body: { active },
      }),
    },
  );
}
